import { c as _c } from "react/compiler-runtime";
import React from "react";
import Logo from "../logo";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogTrigger } from "../ui/dialog";
import { Heading } from "../ui/heading";
import { ArrowRight, Calendar, CheckCircle2, CreditCard, FileText, Lock, Shield, UsersRound, Zap } from "lucide-react";
import { cn } from "@/lib/utils";
import { NUMBER_OF_LEARNERS } from "@/lib/site-config";
import Image from "next/image";
import { Badge } from "../ui/badge";
import { Marker, MarkerContent } from "../ui/marker";
import { getGuestId } from "@/lib/guest-id";
import { cartService } from "@/services/cart";
import { useRouter } from "next/navigation";
const paymentLogos = [{
  name: "Stripe",
  url: "/images/payment/Stripe_Logo.svg"
}, {
  name: "Razorpay",
  url: "/images/payment/Razorpay_logo.svg"
}, {
  name: "Visa",
  url: "/images/payment/Visa_inc.svg"
}, {
  name: "Mastercard",
  url: "/images/payment/Mastercard-logo.svg"
}, {
  name: "Amex",
  url: "/images/payment/American_Express_logo.svg"
}, {
  name: "Discover",
  url: "/images/payment/DiscoverCard.svg"
}, {
  name: "PayPal",
  url: "/images/payment/PayPal.svg"
}];
type EnrollNowDialogProps = {
  isCampaignOffer?: boolean;
  buttonProps?: React.ComponentProps<typeof Button>;
  participant: number;
  course: string;
  date: string;
  data: ServiceEvent;
};
export type Mode = "online" | "proforma-invoice";
export const EnrollNowDialog = t0 => {
  const $ = _c(77);
  const {
    isCampaignOffer,
    buttonProps,
    participant,
    date,
    data,
    course
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== data.countryCode || $[1] !== data.eventDetail.id || $[2] !== data.id || $[3] !== data.offerId || $[4] !== data.serviceId || $[5] !== participant || $[6] !== router) {
    t1 = mode => {
      cartService.addToCart({
        mode,
        countryCode: data.countryCode,
        guestUserId: getGuestId(),
        serviceId: data.serviceId,
        eventId: data.id,
        offerId: data.offerId,
        eventDetailId: data.eventDetail.id,
        quantity: participant || 1
      }).then(() => {
        router.push(`/${data.countryCode}/enrollment-summary?mode=${mode}`);
      });
    };
    $[0] = data.countryCode;
    $[1] = data.eventDetail.id;
    $[2] = data.id;
    $[3] = data.offerId;
    $[4] = data.serviceId;
    $[5] = participant;
    $[6] = router;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleAddtoCart = t1;
  let t2;
  if ($[8] !== buttonProps) {
    t2 = <DialogTrigger render={<Button className="w-full sm:w-55" {...buttonProps}>Enroll Now</Button>} />;
    $[8] = buttonProps;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex justify-center"><Logo width={160} height={20} className="h-6 w-auto" /></div>;
    t4 = <p className="text-muted-foreground mt-2.5 text-xs font-medium">Choose your preferred method to complete enrollment</p>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="from-muted/30 dark:from-muted/10 relative overflow-hidden bg-linear-to-b to-transparent px-6 pt-8 text-center">{t3}{t4}<Marker variant="separator" className="mt-3"><MarkerContent><Badge className="border border-emerald-500/20 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-semibold text-emerald-700 dark:text-emerald-400"><Lock size={12} />Secure End-to-End Encryption</Badge></MarkerContent></Marker></div>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="border-border bg-card absolute top-1/2 -left-1.5 h-3 w-3 -translate-y-1/2 rounded-full border-r" />;
    t7 = <div className="border-border bg-card absolute top-1/2 -right-1.5 h-3 w-3 -translate-y-1/2 rounded-full border-l" />;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-muted-foreground text-[10px] font-bold tracking-wider uppercase">Order Summary</span>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isCampaignOffer) {
    t9 = isCampaignOffer && <Badge className="border-orange-500/20 bg-orange-500/10 text-orange-700 hover:bg-orange-500/20 dark:text-orange-400">Special Offer Applied</Badge>;
    $[16] = isCampaignOffer;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <div className="flex items-center justify-between gap-4">{t8}{t9}</div>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== course) {
    t11 = <Heading as="h6" className="text-foreground line-clamp-2 font-bold tracking-tight">{course}</Heading>;
    $[20] = course;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="border-border h-px border-t border-dashed" />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="bg-primary/5 text-primary flex h-8 w-8 shrink-0 items-center justify-center rounded-lg dark:text-blue-400"><Calendar size={15} /></div>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="text-muted-foreground/80 text-[9px] leading-none font-bold uppercase">Date</div>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== date) {
    t15 = <div className="text-muted-foreground flex min-w-0 items-center gap-3">{t13}<div className="min-w-0">{t14}<div className="text-foreground mt-1 truncate text-xs font-semibold sm:text-sm">{date}</div></div></div>;
    $[25] = date;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="bg-primary/5 text-primary flex h-8 w-8 shrink-0 items-center justify-center rounded-lg dark:text-blue-400"><UsersRound size={15} /></div>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="text-muted-foreground/80 text-[9px] leading-none font-bold uppercase">Learners</div>;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = participant > 1 ? "Learners" : "Learner";
  let t19;
  if ($[29] !== participant || $[30] !== t18) {
    t19 = <div className="text-muted-foreground flex min-w-0 items-center gap-3">{t16}<div className="min-w-0">{t17}<div className="text-foreground mt-1 text-xs font-semibold sm:text-sm">{participant} {t18}</div></div></div>;
    $[29] = participant;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t15 || $[33] !== t19) {
    t20 = <div className="grid grid-cols-2 gap-4 text-sm">{t15}{t19}</div>;
    $[32] = t15;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t20) {
    t21 = <div className="border-border bg-muted/40 dark:bg-muted/10 relative overflow-hidden rounded-xl border p-5">{t6}{t7}<div className="flex flex-col gap-4">{t10}{t11}{t12}{t20}</div></div>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="text-muted-foreground text-[10px] font-bold tracking-wider uppercase">Choose Payment Method</span>;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="flex items-center justify-between">{t22}<span className="text-muted-foreground flex items-center gap-1 text-[11px] font-medium"><Shield size={12} className="text-emerald-500" /> Fully Secured</span></div>;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== handleAddtoCart) {
    t24 = () => handleAddtoCart("online");
    $[41] = handleAddtoCart;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  let t26;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = cn("group border-border bg-card relative flex items-start gap-4 rounded-xl border p-5 text-left transition-all duration-300", "hover:border-emerald-500/50 hover:bg-emerald-50/5 hover:shadow-[0_8px_30px_rgb(0,0,0,0.02)] dark:hover:bg-emerald-950/5", "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none");
    t26 = <div className="absolute inset-0 -z-10 rounded-xl bg-linear-to-b from-emerald-500/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />;
    $[43] = t25;
    $[44] = t26;
  } else {
    t25 = $[43];
    t26 = $[44];
  }
  let t27;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-emerald-500/10 text-emerald-600 transition-all duration-300 group-hover:scale-105 dark:bg-emerald-500/20 dark:text-emerald-400"><CreditCard size={22} /></div>;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <span className="text-foreground text-base font-bold">Pay Online Now</span>;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  let t30;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="flex flex-wrap items-center gap-2">{t28}<span className="inline-flex items-center gap-1 rounded-full border border-emerald-500/20 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-semibold text-emerald-700 dark:text-emerald-400"><Zap size={10} className="fill-current" />Instant</span></div>;
    t30 = <p className="text-muted-foreground mt-1 text-xs leading-normal sm:text-sm">{"Credit/debit card, net banking & digital wallets."}</p>;
    $[47] = t29;
    $[48] = t30;
  } else {
    t29 = $[47];
    t30 = $[48];
  }
  let t31;
  let t32;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="min-w-0 flex-1">{t29}{t30}<div className="mt-2 flex flex-wrap items-center gap-1.5 opacity-70 transition-opacity duration-300 group-hover:opacity-100">{paymentLogos.map(_temp)}</div></div>;
    t32 = <ArrowRight size={18} className="text-muted-foreground/60 mt-1 shrink-0 transition-all duration-300 group-hover:translate-x-1 group-hover:text-emerald-600 dark:group-hover:text-emerald-400" />;
    $[49] = t31;
    $[50] = t32;
  } else {
    t31 = $[49];
    t32 = $[50];
  }
  let t33;
  if ($[51] !== t24) {
    t33 = <button onClick={t24} type="button" className={t25}>{t26}{t27}{t31}{t32}</button>;
    $[51] = t24;
    $[52] = t33;
  } else {
    t33 = $[52];
  }
  let t34;
  if ($[53] !== handleAddtoCart) {
    t34 = () => handleAddtoCart("proforma-invoice");
    $[53] = handleAddtoCart;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  let t36;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = cn("group border-border bg-card relative flex items-start gap-4 rounded-xl border p-5 text-left transition-all duration-300", "dark:hover:bg-primary-950/5 hover:border-primary/50 hover:bg-primary/5 hover:shadow-[0_8px_30px_rgb(0,0,0,0.02)]", "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none");
    t36 = <div className="from-primary/5 absolute inset-0 -z-10 rounded-xl bg-linear-to-b to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />;
    $[55] = t35;
    $[56] = t36;
  } else {
    t35 = $[55];
    t36 = $[56];
  }
  let t37;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="bg-primary/10 text-primary dark:bg-primary/20 flex h-12 w-12 shrink-0 items-center justify-center rounded-xl transition-all duration-300 group-hover:scale-105 dark:text-blue-400"><FileText size={22} /></div>;
    $[57] = t37;
  } else {
    t37 = $[57];
  }
  let t38;
  let t39;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div className="min-w-0 flex-1"><div className="flex items-center gap-2"><span className="text-foreground text-base font-bold">Pay via Bank Transfer</span><span className="border-primary/20 bg-primary/10 text-primary inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold dark:text-blue-400">Invoice</span></div><p className="text-muted-foreground mt-1 text-xs leading-normal sm:text-sm">Generate a proforma invoice and process bank transfer wire.</p></div>;
    t39 = <ArrowRight size={18} className="text-muted-foreground/60 group-hover:text-primary mt-1 shrink-0 transition-all duration-300 group-hover:translate-x-1 dark:group-hover:text-blue-400" />;
    $[58] = t38;
    $[59] = t39;
  } else {
    t38 = $[58];
    t39 = $[59];
  }
  let t40;
  if ($[60] !== t34) {
    t40 = <button onClick={t34} type="button" className={t35}>{t36}{t37}{t38}{t39}</button>;
    $[60] = t34;
    $[61] = t40;
  } else {
    t40 = $[61];
  }
  let t41;
  if ($[62] !== t33 || $[63] !== t40) {
    t41 = <div className="grid gap-4">{t33}{t40}</div>;
    $[62] = t33;
    $[63] = t40;
    $[64] = t41;
  } else {
    t41 = $[64];
  }
  let t42;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-400"><CheckCircle2 size={20} /></div>;
    $[65] = t42;
  } else {
    t42 = $[65];
  }
  let t43;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <p className="text-foreground text-xs font-semibold sm:text-sm">Join {NUMBER_OF_LEARNERS} professionals</p>;
    $[66] = t43;
  } else {
    t43 = $[66];
  }
  let t44;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="border-border/60 bg-muted/20 dark:bg-muted/5 flex flex-col items-center gap-4 rounded-xl border p-4 sm:flex-row">{t42}<div className="flex-1 text-center sm:text-left">{t43}<p className="text-muted-foreground text-[11px] sm:text-xs">who have already upskilled with{" "}<span className="text-primary font-semibold dark:text-blue-400">Spoclearn</span>{" "}globally.</p></div></div>;
    $[67] = t44;
  } else {
    t44 = $[67];
  }
  let t45;
  let t46;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <div className="flex items-center gap-1.5"><Shield size={13} className="text-emerald-500" /><span>PCI-DSS Compliant</span></div>;
    t46 = <div className="bg-border/60 hidden h-3 w-px sm:block" />;
    $[68] = t45;
    $[69] = t46;
  } else {
    t45 = $[68];
    t46 = $[69];
  }
  let t47;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <div className="border-border/40 text-muted-foreground flex flex-wrap items-center justify-center gap-4 border-t pt-5 text-[11px] font-medium">{t45}{t46}<div className="flex items-center gap-1.5"><Lock size={13} className="text-primary dark:text-blue-400" /><span>256-bit SSL Secured Connection</span></div></div>;
    $[70] = t47;
  } else {
    t47 = $[70];
  }
  let t48;
  if ($[71] !== t21 || $[72] !== t41) {
    t48 = <DialogContent className="border-border bg-card max-h-[90vh] overflow-hidden rounded-2xl border p-0 shadow-2xl transition-all sm:max-w-2xl">{t5}<div className="no-scrollbar max-h-[75vh] space-y-6 overflow-y-auto p-6">{t21}{t23}{t41}{t44}{t47}</div></DialogContent>;
    $[71] = t21;
    $[72] = t41;
    $[73] = t48;
  } else {
    t48 = $[73];
  }
  let t49;
  if ($[74] !== t2 || $[75] !== t48) {
    t49 = <Dialog>{t2}{t48}</Dialog>;
    $[74] = t2;
    $[75] = t48;
    $[76] = t49;
  } else {
    t49 = $[76];
  }
  return t49;
};
function _temp(logo) {
  return <div key={logo.name} className="border-border/40 relative flex h-7 w-14 items-center justify-center rounded-md border bg-white shadow-xs dark:bg-white/10"><Image src={logo.url} alt={logo.name} fill={true} priority={true} sizes="(max-width: 768px) 100vw, 80px" className="h-auto w-auto object-contain p-1.5 transition-all duration-300 dark:opacity-100 dark:brightness-0 dark:invert dark:filter" /></div>;
}